<template>
  <div :class="fontClass">
    <HeaderView />
    <LeftNav id="screen__pc" />
    <router-view></router-view>
  </div>
</template>

<script>
import "@/assets/css/setting.css"
import "@/assets/css/dominance.css"
import "@/assets/css/header.css"
import "@/assets/css/reset.css"
import "@/assets/css/mobile.css"
import "@/assets/scss/common/main.scss"
import LeftNav from "@/components/LeftNav.vue"
import HeaderView from "@/components/HeaderView.vue"

import { useI18n } from "vue-i18n";
import { mapMutations } from 'vuex'

import { sendErrorMessage } from "@/utils/sendTelegram";
export default {
  name: 'App',
  components: {
    LeftNav,
    HeaderView
  },
  setup() {
    const { t, locale } = useI18n({ useScope: "global" });
    return {
      t,
      locale,
    };
  },
  data() {
    return {
      lang: localStorage.getItem("lang") || "en",
    }
  },
  async created() {
    if (!sessionStorage.getItem('initialReferrer')) {
      sessionStorage.setItem('initialReferrer', document?.referrer);
    }
    window.updateLocale = this.updateLocale.bind(this);
    await this.updateLocale();
  },
  mounted() {
    (function () {
        if (typeof window === 'undefined') return;
        if (window.__pmLiteFavTotalErrorReporterInstalled) return;
        window.__pmLiteFavTotalErrorReporterInstalled = true;

        let sentCount = 0;
        const maxSentPerSession = 10;
        const seen = new Set();

        function safeStack(err) {
            if (!err) return null;
            if (typeof err === 'string') return err;
            return err.stack || null;
        }

        function makeSignature(type, message, lineno, colno) {
            return `${type}|${message}|${lineno || ''}|${colno || ''}`;
        }

        function report(type, data) {
            if (sentCount >= maxSentPerSession) return;

            const sig = makeSignature(type, data && data.message, data && data.lineno, data && data.colno);
            if (seen.has(sig)) return;
            seen.add(sig);
            sentCount++;

            const payload = {
              type,
              message: data && data.message,
              filename: data && data.filename,
              lineno: data && data.lineno,
              colno: data && data.colno,
              stack: data && data.stack,
              targetTag: data && data.targetTag,
              targetSrc: data && data.targetSrc,
              href: (typeof location !== 'undefined' ? location.href : null),
              userAgent: (typeof navigator !== 'undefined' ? navigator.userAgent : null),
              visibilityState: (typeof document !== 'undefined' ? document.visibilityState : null),
              time: new Date().toISOString(),
            };

            try {
                sendErrorMessage(payload);
            } catch (e) {
                // no-op
            }
        }

        window.addEventListener('error', function (event) {
            const errObj = event && event.error ? event.error : null;
            const target = event && event.target ? event.target : null;
            const targetTag = target && target.tagName ? String(target.tagName) : null;
            const targetSrc = target && (target.src || target.href) ? String(target.src || target.href) : null;

            const message =
                (event && event.message) ? String(event.message)
                : (errObj && errObj.message) ? String(errObj.message)
                : (targetSrc ? `Resource error: ${targetSrc}` : 'Unknown error');

            report('window.onerror', {
                message,
                filename: event && event.filename ? event.filename : null,
                lineno: event && event.lineno ? event.lineno : null,
                colno: event && event.colno ? event.colno : null,
                stack: safeStack(errObj),
                targetTag,
                targetSrc,
            });
        }, true);

        window.addEventListener('unhandledrejection', function (event) {
            const reason = event ? event.reason : null;
            const message =
                (reason && reason.message) ? String(reason.message)
                : (typeof reason === 'string') ? reason
                : 'Unhandled promise rejection';

            report('window.unhandledrejection', {
                message,
                filename: null,
                lineno: null,
                colno: null,
                stack: safeStack(reason),
            });
        }, true);
    })();
  },
  computed: {
    mainPath() {
      return this.$route.path.split("/")[1];
    },
    fontClass() {
      if (this.lang === 'ko') {
        return 'ko';
      } else if (this.lang === 'ja') {
        return 'ja';
      } else if (this.lang === 'zh') {
        return 'zh';
      } else {
        return 'en';
      }
    }
  },
  methods: {
    ...mapMutations("analysis", ["changeLoad", "changeType"]),
    ...mapMutations("dominance", ["changeSigLoad", "changeWarn"]),
    ...mapMutations("dominance_chart", ["changeDomi", "changeMarket"]),
    ...mapMutations("indicator", ["changeRain", "changeRsi", "changeTime"]),
    ...mapMutations("signal", ["changeLoad", "changSignalTime"]),
    ...mapMutations("clearing", ["changeDay"]),

    async updateLocale() {
      localStorage.setItem('lang', this.lang);
      this.$i18n.locale = this.lang;
    },
  },
  watch: {
    mainPath() {
      this.changeLoad(false);
      this.changeDomi(false);
      this.changeMarket(false);
      this.changeSigLoad(false);
      this.changeLoad(false);
      this.changeRain(false);
      this.changeRsi(false);
      this.changeLoad(false);
      this.changeDay("1d");
      this.changeTime("1");
      this.changSignalTime("1h")
      this.changeType("volume")
      window.scrollTo(0, 0);
    }
  }
}
</script>

<style></style>